import styled from 'styled-components'

export const PlantSelectWrapper = styled.div`
  padding: 1rem;
  flex: 1;
  display: ${(props) => !props.theme.isMobile && 'flex'};
  flex-direction: column;
`

export const SearchBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: ${(props) => (props.theme.isMobile ? '3rem' : '')};
`

export const IconWrapper = styled.div`
  padding: 1rem;
  flex: 0;
`

export const SearchInput = styled.input`
  flex: 1;
  padding: 1rem;
  background-color: ${(props) => props.theme.colors.whiteAlpha20};
  border: none;
  border-radius: 4px;
  color: ${(props) => props.theme.colors.white};
  margin-bottom: 1rem;
  &::placeholder {
    color: ${(props) => props.theme.colors.white};
  }
  &:focus {
    outline: none;
  }
`

export const PlantElementWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1rem;
  background-color: ${(props) => props.theme.colors.neutralColor500};
  border-radius: 4px;
  margin: 0.5rem 0;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.colors.neutralColor300};
  }
  justify-content: ${(props) => (props.theme.isMobile ? 'flex-start' : '')};
`

export const PlantFlexDiv = styled.div`
  flex: 1 1 0%;
`

export const CenterWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & p {
    padding: 0.5rem;
  }
`
